import { render } from "./ResetPasswordForm.vue?vue&type=template&id=359ecca4&scoped=true"
import script from "./ResetPasswordForm.vue?vue&type=script&lang=js"
export * from "./ResetPasswordForm.vue?vue&type=script&lang=js"

import "./ResetPasswordForm.vue?vue&type=style&index=0&id=359ecca4&scoped=true&lang=scss"

import exportComponent from "J:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-359ecca4"]])

export default __exports__